import { ReactiveMap } from '../../../../utils/ReactiveMap';

export const deleteAssetsActionTrackerState = new ReactiveMap<
  string,
  string[],
  'deleteAssetsTracker'
>();
